import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { isLoggedInSelector } from '../redux/reducers/app/params';
import { getCookie } from '../utils/cookie';
import { PageEventButton } from '../redux/helpers/aba-models';
import {
  CASHIER_NAVIGATE_COOKIE_NAME,
  CASHIER_NAVIGATE_COOKIE_VALUE,
} from '../constants/ABA';
import { NAMESPACES } from '../constants/namespaces';
import { useTranslate } from './useTranslate';

export const useDepositButton = () => {
  const translate = useTranslate(NAMESPACES.INITIAL);
  const isLoggedIn = useSelector(isLoggedInSelector);
  const cashierNavigateValue = getCookie(CASHIER_NAVIGATE_COOKIE_NAME);
  const depositButton = useMemo(
    () =>
      new PageEventButton('redirect-cashier', translate('Deposit')).toObject(),
    [translate]
  );

  return useMemo(
    () =>
      cashierNavigateValue === CASHIER_NAVIGATE_COOKIE_VALUE && isLoggedIn
        ? depositButton
        : null,
    [cashierNavigateValue, depositButton, isLoggedIn]
  );
};
